<template>
  <transition name="opacity-fade">
    <div
      id="base-box-with-if"
      @click="goTo(slideID, currentSlide)"
      v-if="shouldIShowIt(slide.hidden, currentSlide, slideID)"
      :style="{ background: bbbcg, width: '100%', height: '100%', position: 'absolute' }"
    >
      <div
        class="box"
        :id="slideID"
        :style="{
          backgroundColor: slide.styleCSS.background,
          backgroundImage: giveMeBackgroundPlease(slide.styleCSS.backgroundImage),
          width: slide.styleCSS.width + '%',
          height: slide.styleCSS.height + '%',
          marginTop: (100 - slide.styleCSS.height) / 4 + '%',
          marginLeft: (100 - slide.styleCSS.width) / 2 + '%',
          boxShadow: slide.styleCSS.shadow || '0vh 0vh 2vh .5vh rgba(0,0,0,0.34)',
          'border-radius': setValue(slide.styleCSS.borderRadius, '2em'),
        }"
      >
        <div class="boxInTheBox" v-if="currentSlide == slideID" style="width: 100%; height: 100%; position: relative">
          <div :key="slide.name + item.type + index" v-for="(item, index) in slide.items">
            <box-in-the-box :item-data="item"></box-in-the-box>
          </div>
          <transition name="controll" v-for="(cc, indexCC) in slide.comicControll" :key="'CCbind' + indexCC">
            <comic-controlls
              v-if="showComic &amp;&amp; autoPlay && checkBinding(cc.bind) && chceckMineBinding(cc.bind)"
              :item-style="cc"
              :slide-name="slideID"
            ></comic-controlls>
          </transition>
          <div class="audioBox" v-if="slide.audio" :class="{ 'slap-to-the-left': audioVisible }"></div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import boxInTheBox from './awesomeBoxInTheBox/boxInTheBox';
import comicControlls from './awesomeSvg/comicControlls';
export default {
  name: 'base-box-with-if',
  components: { boxInTheBox, comicControlls },
  props: {
    bbx: {
      default: '0vw',
      type: String,
    },
    bby: {
      default: '0vh',
      type: String,
    },
    bbbcg: {
      default: 'transparent',
      type: String,
    },
    slide: {
      default: null,
      type: Object,
    },
    slideID: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      canIPlayASong: true,
      blockAnim: false,
      animated: false,
    };
  },
  methods: {
    setValue(value, defaultVal) {
      return value ? value : defaultVal;
    },
    giveMeBackgroundPlease(path) {
      if (path) {
        let img = require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
        return 'url(' + img + ')';
      }
    },
    goTo(go, currentSlide) {
      if (go && currentSlide != go) {
        this.$parent.$parent.$emit('goToStepNow', go);
        this.$store.commit('STATE_SET_GO_TO', go);
      }
    },
    shouldIShowIt(hidden, currentSlide, slideID) {
      if (hidden) {
        if (currentSlide == slideID) return true;
        else return false;
      } else return true;
    },
    comicInteraction() {
      this.$store.commit('STATE_COMIC_SHOW', !this.showComic);
    },
    soundEnd() {},
    info() {
      this.canIPlayASong = true;
    },
    checkBinding(bind) {
      console.log('GLOB' + this.binding);
      console.log('LOC' + bind);
      if (this.binding != '') {
        if (this.binding == bind || this.binding == 'all') {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    chceckMineBinding(bind) {
      if (this.mainBind != 'all' && this.mainBind != '') {
        if (bind) {
          if (bind == this.mainBind) return true;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  computed: {
    mainBind() {
      return this.$store.getters.getCurrentMainBind;
    },
    binding() {
      return this.$store.getters.getCurrentBind;
    },
    showComic() {
      return this.$store.getters.getComicShow;
    },
    currentSlide() {
      return this.$store.getters.getCurrentStep;
    },
    audioVisible() {
      return this.$store.getters.getAudio;
    },
    autoPlay() {
      return this.$store.getters.getAutoMove;
    },
  },
};
</script>
<style lang="sass" scoped>
#base-box-with-if
  width: 100%
  height: 100%
  .box
    overflow: hidden
    //background-position: center
    background-repeat: no-repeat
    background-size: cover
    position: absolute
    border-radius: 2em
    transition: .5s
    animation: 1s 0s showMe 1 linear backwards
    @keyframes showMe
      0%
        opacity: 0
      100%
        opacity: 1

    .boxInTheBox
      display: block

    .topography
      height: calc(1080px * 0.05)
      width: 100vw
      background: rgba(255,255,255,.3)
      position: fixed
      top: calc(1080px * 0.95)
      left: 0vw
      padding-top: calc(1080px * 0.005)
      .goLeft, .goRight
        height: calc(1080px * 0.04)
        width: calc(1080px * 0.04)
        line-height: calc(1080px * 0.04)
        border-radius: 50%
        display: inline-block
        background: transparent
        overflow: hidden
        i
          line-height: calc(1080px * 0.04)
          font-size: 2em
          width: 100%
          transition: all .3s ease-in-out
          &:hover
            transform: scale(1.5, 1.5)
            color: #6DD5FA
      .ballBox
        display: inline-block
        height: calc(1080px * 0.04)
        width: calc(1080px * 0.04)
        background: transparent
        .ball
          margin: auto
          margin-top: calc(1080px * 0.04 * .2)
          height: 60%
          width: 60%
          background: rgba(0,0,0,.3)
          transition: all .3s ease-in-out
          border-radius: 50%
          &:hover
            background: rgba(106, 154, 171, 0.5)
          .trueBall
            height: 100%
            width: 100%
            background: #6DD5FA
            border-radius: 50%
  .scalemove
    animation-name: example
    animation-duration: 10s

.info-fade-leave-active, .info-fade-enter-active, .translate-x-fade-leave-active, .translate-x-fade-enter-active, .rotate-fade-leave-active, .rotate-fade-enter-active, .skew-x-fade-leave-active, .skew-x-fade-enter-active
  transition: all .5s linear

.opacity-fade-leave-active, .opacity-fade-enter-active
  transition: all .5s linear
.opacity-fade-leave-active
  transition: all .5s .5s linear
.opacity-fade-leave-to, .opacity-fade-enter
  opacity: 0

.info-fade-leave-to, .info-fade-enter
  transform: scale(0,0)
  opacity: 0

.rotate-fade-leave-to, .rotate-fade-enter
  transform: rotate(15deg)
  opacity: 0

.translate-x-fade-leave-to, .translate-x-fade-enter
  transform: translateX(calc(1920px * 0.1))
  opacity: 0

.skew-x-fade-leave-to, .skew-x-fade-enter
  transform: skewX(20deg)
  opacity: 0

.rotate-fade-enter-active, .info-fade-enter-active, .skew-x-fade-enter-active, .translate-x-fade-enter-active
  transition-delay: .5s
</style>
